import type { UiSearchBaseInputEntry } from '@/ui/Search/types';
import { searchFormInOperators } from '@/ui/Search/operators';

export const searchID: UiSearchBaseInputEntry<'id'> = {
  name: 'id',
  type: 'tags',
  field: { label: 'ID' },
  input: { placeholder: 'Type an ID and press Enter' },
  icon: ['fal', 'hashtag'],
};
export const searchCreationTime: UiSearchBaseInputEntry<'creationTime'> = {
  name: 'creationTime',
  type: 'calendar',
  field: { label: 'Created At' },
  input: { placeholder: 'Search by creation time', type: 'datetime-local' },
  icon: ['fal', 'calendar'],
};
export const searchLastUpdateTime: UiSearchBaseInputEntry<'lastUpdateTime'> = {
  name: 'lastUpdateTime',
  type: 'calendar',
  field: { label: 'Last Updated At' },
  input: { placeholder: 'Search by last update time', type: 'datetime-local'  },
  icon: ['fal', 'calendar'],
};

export const searchCreatedBy: UiSearchBaseInputEntry<'createdBy'> = {
  name: 'createdBy',
  type: 'generic',
  field: { label: 'Created By' },
  icon: ['fal', 'user'],
  operators: searchFormInOperators,
};

export const searchLastUpdateBy: UiSearchBaseInputEntry<'lastUpdateBy'> = {
  name: 'lastUpdateBy',
  type: 'generic',
  field: { label: 'Last Updated By' },
  icon: ['fal', 'user'],
  operators: searchFormInOperators,
};


